module.exports = __webpack_public_path__ + "static/img/home-bg.4400add.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-bg.jpg
// module id = 3b/Y
// module chunks = 1